export default __webpack_public_path__ + "static/media/Slider-01.957d77d2.jpg";